export const delay = time => (...data) => {
	return new Promise(resolve => {
		setTimeout(() => resolve(...data), time)
	})
}



// WEBPACK FOOTER //
// ./src/helper/time.js